import { GameNames } from "../store/slices/GameTypes";
import { setLastUpdated } from "../store/slices/gameObjectSlice";
import { TSoundINT, setSound } from "../store/slices/soundsSlice";
import { store } from "../store/store";
import { Action } from "./Actions/Action";

export interface SoundOptions {
    shouldPlay: boolean;
    loop?: boolean;
    type?: 'sound' | 'music';
    multiplePlay?: boolean;
}

export interface SoundObject {
    [key: string]: TSoundINT & { key?: string; };
}
export function asSounds<T extends SoundObject>(arg: T): { [Key in keyof T]: Omit<T[Key], "url"> & { key: string, url: string; } } {
    if (typeof arg === "object") {
        Object.keys(arg).forEach(key => {

            const newUrl = (arg[key].url as any).default || arg[key].url;
            arg[key].key = key;
            arg[key].url = newUrl;


        });
    }
    return arg as { [Key in keyof T]: T[Key] & { key: string; } };
}

export default class SoundClass {

    constructor() { }
    static startSound(sound: TSoundINT, options: SoundOptions): any {
        const data: TSoundINT = { ...sound, options: { ...options!, type: "sound" } };
        return new Action(data, GameNames.SOUND).run(
            function sound(callback: () => void) {
                store.dispatch(setLastUpdated({ updatedValue: GameNames.SOUND, shouldStop: false }));
                store.dispatch(setSound(data));
                callback();
            }
        );
    }
    static stopSound(sound: TSoundINT): any {
        const data: TSoundINT = { ...sound };
        return new Action(data, GameNames.SOUND).run(
            function sound(callback: () => void) {
                store.dispatch(setLastUpdated({ updatedValue: GameNames.SOUND, shouldStop: false }));
                store.dispatch(setSound(data));
                callback();
            }
        );
    }
    static startMusic(sound: TSoundINT, options: SoundOptions): any {
        const data: TSoundINT = { ...sound, options: { ...options!, type: "music" } };
        return new Action(data, GameNames.SOUND).run(
            function sound(callback: () => void) {
                store.dispatch(setLastUpdated({ updatedValue: GameNames.SOUND, shouldStop: false }));
                store.dispatch(setSound(data));
                callback();
            }
        );
    }
    static stopMusic(sound: TSoundINT): any {
        const data: TSoundINT = { ...sound };
        return new Action(data, GameNames.SOUND).run(
            function sound(callback: () => void) {
                store.dispatch(setLastUpdated({ updatedValue: GameNames.SOUND, shouldStop: false }));
                store.dispatch(setSound(data));
                callback();
            }
        );
    }

}